import { Button, Result } from "antd";
import React from "react";
import { withTranslation } from "react-i18next";
import { IPageNotFoundProps } from "../../models/interface/IPageNotFoundProps";
import "./style.scss";

const PageComingSoon = ({ t, history }: IPageNotFoundProps) => {
  return (
    <div className={"kd-page-coming-soon"}>
      <Result
        // status=""
        // icon={<></>}
        title="COMING SOON"
        subTitle={t("english_coming_soon")}
        extra={
          <Button type="primary" onClick={() => history.replace("/vn/")}>
            {t("back_to_home")}
          </Button>
        }
      />
    </div>
  );
};

export default withTranslation()(PageComingSoon);
